import React, {useLayoutEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import PicButton from '../../../../../../../../../../../../../../components/pic-button/index';
import {dropDownPosition} from '../../../../../../../../../../../../../../utils';
import EditContactButton from './components/edit-contact-button';
import DeleteContactButton from './components/delete-contact-button';
import AddToLabelButton from './components/add-to-label-button';
import ShareContactButton from './components/share-contact-button';
import CommentsButton from './components/comments-button';
import RemoveFromLabelButton from './components/remove-from-label-button';
import './index.css';

function MoreContactButton ({ contactId, contactName, contactEmail, contactType, history, editable, shareable, deletable, fromAutocomplete }) {

	const [displayMoreOption, setDisplayMoreOption] = useState(false);

	const { t } = useTranslation();

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const profile = useSelector(state => state.profileReducer.getProfile);

	useLayoutEffect(() => {
		if(displayMoreOption){
			dropDownPosition(document.querySelector('.contact'), document.querySelector(`#contact-${contactId} .more-options`), document.querySelector('.more-options-dropdown'));
		}
	}, [displayMoreOption, contactId]);

	const handleClick = (e) => {
		e.stopPropagation();
		e.preventDefault();

		setDisplayMoreOption(prevState => {
			return !prevState;
		});
	};

	const mouseLeave = () => {
		setDisplayMoreOption(false);
	};

	return (
		<>
			<PicButton className="more-options" onClick={handleClick}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path
						fill="currentColor"
						d="M 12 24 C 11.175 24 10.469 23.706 9.881 23.119 C 9.294 22.531 9 21.825 9 21 C 9 20.175 9.294 19.469 9.881 18.881 C 10.469 18.294 11.175 18 12 18 C 12.825 18 13.531 18.294 14.119 18.881 C 14.706 19.469 15 20.175 15 21 C 15 21.825 14.706 22.531 14.119 23.119 C 13.531 23.706 12.825 24 12 24 Z M 12 15 C 11.175 15 10.469 14.706 9.881 14.119 C 9.294 13.531 9 12.825 9 12 C 9 11.175 9.294 10.469 9.881 9.881 C 10.469 9.294 11.175 9 12 9 C 12.825 9 13.531 9.294 14.119 9.881 C 14.706 10.469 15 11.175 15 12 C 15 12.825 14.706 13.531 14.119 14.119 C 13.531 14.706 12.825 15 12 15 Z M 12 6 C 11.175 6 10.469 5.706 9.881 5.119 C 9.294 4.531 9 3.825 9 3 C 9 2.175 9.294 1.469 9.881 0.881 C 10.469 0.294 11.175 0 12 0 C 12.825 0 13.531 0.294 14.119 0.881 C 14.706 1.469 15 2.175 15 3 C 15 3.825 14.706 4.531 14.119 5.119 C 13.531 5.706 12.825 6 12 6 Z"/>
				</svg>
			</PicButton>
			{
				displayMoreOption && (
					<ul className="more-options-dropdown" onMouseLeave={mouseLeave}>
						<li>
							<EditContactButton
								disabled={selectedContactsGroup.directorySyncStatus === 'RUNNING' || (contactType !== 'directory' && !editable && profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false)}
								history={history}
								title={t("editContact")}
								contactId={contactId}
								selectedLabelId={selectedContactsGroup.type === "system" ? 6 : selectedContactsGroup.id}
								contactType={contactType}
							/>
						</li>
						<li>
							<CommentsButton
								contactId={contactId}
								contactType={contactType}
								title={t("textComment")}
								disabled={selectedContactsGroup.directorySyncStatus === 'RUNNING'}
							/>
						</li>
						{(!profile || profile.role !== 'RESTRICTED_USER') && (
							<li>
								<ShareContactButton
									disabled={!shareable || selectedContactsGroup.directorySyncStatus === 'RUNNING'}
									title={t("shareContact")}
									contactId={contactId}
									contactName={contactName}
									contactType={contactType}
								/>
							</li>
						)}
						<li>
							<AddToLabelButton
								disabled={!editable || selectedContactsGroup.directorySyncStatus === 'RUNNING'}
								title={t("attachContact")}
								contactId={contactId}
								contactName={contactName}
								contactType={contactType}
							/>
						</li>
						{
							selectedContactsGroup.type !== 'system' && !fromAutocomplete
							&& selectedContactsGroup.directorySyncStatus !== 'RUNNING'
							&& <li>
								<RemoveFromLabelButton disabled={!editable} contactId={contactId} contactType={contactType} title={t("removeContactHoverText")}/>
							</li>
						}
						<li>
							<DeleteContactButton
								disabled={!deletable || contactType !== 'contact' || selectedContactsGroup.directorySyncStatus === 'RUNNING'}
								contactId={contactId}
								contactEmail={contactEmail}
								contactType={contactType}
								title={t("textDeleteContactBtn")}
							/>
						</li>

					</ul>
				)
			}
		</>
	);
}

export default MoreContactButton;
